import {Box, SxProps, Theme} from "@mui/material";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const markdownStyles: SxProps<Theme> = {
    "& table": {
        borderCollapse: "collapse",
        marginBlock: 3,
        marginInline: "auto",
    },
    "& th, & td": {
        border: "1px solid",
        borderColor: "divider",
        padding: "10px 20px",
        textAlign: "left",
    },
    "& th": {
        backgroundColor: "action.hover",
        fontWeight: 600,
    },
    "& code": {
        backgroundColor: "action.hover",
        borderRadius: "12px",
        padding: "2px 10px",
        fontSize: "0.875em",
        fontFamily: "inherit",
        fontWeight: 500,
    },
    "& img": {
        maxWidth: "100%",
        height: "auto",
    },
};

interface MarkdownContentProps {
    children: string;
    sx?: SxProps<Theme>;
}

export default function MarkdownContent({children, sx}: MarkdownContentProps) {
    return (
        <Box sx={[markdownStyles, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
            <Markdown remarkPlugins={[remarkGfm]}>{children}</Markdown>
        </Box>
    );
}
